import {getState} from '../store'

export default () => getState().getIn(['conversations', '_stack', 'visibleSlot'], null)



/** WEBPACK FOOTER **
 ** ./modules/shared/data/getters/stack_visible_slot.js
 **/